import React, {useEffect, useState} from "react";

import { Link } from 'react-router-dom'
import alertify from 'alertifyjs';

import repository         from './repository';
import { Form, IconList } from '@/componentes/form/styles';
import Template           from '@/modules/admin/template';
import useForm            from '@/componentes/form/useForm';

import ComboGroup from '@/modules/admin/combos/group';

export function UserForm(props) {

    const url = "/admin/users";

    const dataInitial = {
        name: "",
        login: "",
        password: "",
        group: 0,
        status: true,
        id: 0
    };

    const {values, setValues, handleChange, clearForm} = useForm(dataInitial);
    
    useEffect(() => {

        if (props.match.params.id) {
            
            repository.getView(props.match.params.id, (response) => {

                setValues(response.data);                
            });
        }
   
    }, [props.match.params.id, setValues]);

    const handleSubmit = (e) => {

        e.preventDefault();

        repository.save(values, (response) => {

            alertify.success(response.data.message);
    
            clearForm();
    
            props.history.push(url);
        });
    }

    return (
        <>
            <Template title="Usuários">

                <Form onSubmit={handleSubmit}>
                    <main className="container">
                        
                        <div className="row">
                            <div className="col-sm-12">
                                <Link to={url}>
                                    <IconList size={30} />
                                </Link>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-6">
                                <label htmlFor="group">Grupo</label>
                                <ComboGroup handle={handleChange} name="group" value={values.group} />
                            </div>
                            <div className="col-sm-6">
                                <label>Nome</label>
                                <input type="text" 
                                        name="name" 
                                        id="title" 
                                        maxLength="50" 
                                        value={values.name}
                                        onChange={handleChange} />
                            </div>
                        </div>
                       
                        <div className="row">
                            <div className="col-sm-6">
                                <label htmlFor="login">Login</label>
                                <input type="text" 
                                        name="login" 
                                        id="login" 
                                        maxLength="30" 
                                        value={values.login}
                                        onChange={handleChange} />
                            </div>
                            <div className="col-sm-6">
                                <label htmlFor="status">Status</label>
                                <select value={values.status} onChange={handleChange} name="status" id="status" >
                                    <option value={true}>Ativo</option>
                                    <option value={false}>Desativado</option>
                                </select>
                            </div>
                        </div>
                        <div className="row" >

                           {values.id === 0 ?  
                             <div className="col-sm-6">
                                <label htmlFor="password">Senha</label>
                                <input type="password" 
                                        name="password" 
                                        id="password" 
                                        maxLength="30" 
                                        value={values.password}
                                        onChange={handleChange} />

                            </div> : "" }
                        </div>
                        <div className="row">
                            <button>Salvar</button>
                        </div>
                    </main>
                </Form>
            </Template>
        </>
    )
}

export default UserForm;